<template>
  <div style="height: 100%;">
    <!--楼顶给排水-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>给排水监测</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
      <no-data style="margin-top: 20%;" v-if="data.length < 1"></no-data>
      <span :key="item.id" v-else v-for="item in data">
        <div style="margin-bottom: 4%;border: 1px solid rgba(41, 159, 251, 0.2);width: 90%;margin: 0px 0px 15px 20px;padding-top: 3%">
         <span style="font-weight: bold;font-size: 1rem;margin-left: 36%">{{ item.name }}</span>
          <el-row style="padding: 23px 0 5px 23px;">
        <el-col :span="6" style="margin-top: -1%;margin-right: -2%">
          <img style="width: 55%" src="../../../assets/images/comprehensive/水位.png">
        </el-col>
        <el-col :span="6" style="position: relative">
          <div style="margin-left: -26%">
            <span class="text-blue" style="font-weight: bold;font-size: 18px;position: absolute;top: 20%" :style="{color: item.waterLevel < 0.5 ? '#00D488' : '#F95453'}">{{item.waterLevel}}m</span>
            <span style="position: absolute;top: 21px;font-size: 1px;color: #FFFFFF;opacity: 60%">水位高度</span>
          </div>
        </el-col>
             <span style="height: 45px; border-left: 2px solid #364149; display: inline-block;position: absolute;right: 53%;opacity: 0.5"></span>
             <el-col :span="6" style="margin-top: -1%">
                <img style="width: 55%;margin-left: 105%" src="../../../assets/images/comprehensive/电磁阀.png">
                </el-col>
             <el-col :span="6" style="position: relative">
               <div style="margin-left: -26%;position: absolute;left: 105%">
                <el-switch @change="change()"
                           v-model="value"
                           active-color="#00CFAC"
                           inactive-color="#F95453"
                           active-value="1"
                           inactive-value="0"
                           active-text="开"
                           inactive-text="关"
                           style="width: 90%"></el-switch>
                <span style="font-size: 1px;color: darkgray">电磁阀开关</span>
                 </div>
               </el-col>
            <el-col :span="21">
          <span style="font-size: 1px;color: #CFA826">*最高水位线为1m</span>
            </el-col>
      </el-row>
          </div>
      </span>
    </div>

  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";

export default {
  name: "Water",
  components: {NoData},
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      data: [
        {
          name:"楼顶给排水",
          waterLevel:"0.1",
          open:"0"
        },
        {
          name:"水箱给排水",
          waterLevel:"0.5",
          open:"1"
        },
        {
          name:"地下给排水",
          waterLevel:"0.5",
          open:"1"
        }
      ],
      video: [],
      typeList: ["PM_FIRE", "Video_vlc", "PM_CAM"],
      pointCodes: [],
      value:'0'
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getSmoke:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getSmoke')
  },
  methods: {
    // getData() {
      // getLinkDeviceBySpacePoint({
      //   spaceId: this.spaceId,
      //   typeList: this.typeList,
      //   pointCodes: this.pointCodes
      // }).then(res => {
      //   if (res.code === 0) {
      //     if (res.data.length > 0) {
      //       res.data.forEach(item => {
      //         if (item.typeEngName === 'PM_FIRE') {
      //           this.data = item.linkDeviceInfoList
      //         }
      //       })
      //
      //     }
      //   }
      // })
    // },
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.data = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(deviceInfo => {
                this.data.push(deviceInfo);
              })
            })
          }
        }
      })
    },
    change() {

    }
  }
}
</script>

<style scoped>

</style>
